import { render } from "./TiepaiManagement.vue?vue&type=template&id=ec601e92&scoped=true"
import script from "./TiepaiManagement.vue?vue&type=script&lang=js"
export * from "./TiepaiManagement.vue?vue&type=script&lang=js"

import "./TiepaiManagement.vue?vue&type=style&index=0&id=ec601e92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec601e92"]])

export default __exports__